export default __webpack_public_path__ + "static/media/distocia_de_hombros.f568f66b.pdf";